import GKCharts from "components/GKCharts";
import _ from "lodash";

interface MFSchemeWeightageProps {
  mfHoldingsData?: any[];
}

const MFSchemeWeightage = (props: MFSchemeWeightageProps) => {
  const { mfHoldingsData } = props;

  const totalMFValue = _.sum(
    mfHoldingsData.map((item: any) => item.currentAmount),
  );

  const mfSchemeChartData = mfHoldingsData.map((item: any) => ({
    name: item.asset?.schemeName || item.asset?.name,
    y: totalMFValue
      ? +((item.currentAmount / totalMFValue) * 100).toFixed(2)
      : 0,
  }));

  const options = {
    chart: {
      type: "pie",
      height: 300,
      width: 300,
      style: { margin: "0 auto" },
    },

    title: {
      text: "",
    },

    tooltip: {
      headerFormat: "",
      pointFormat: "<b>{point.name}</b>",
    },

    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },

    plotOptions: {
      pie: {
        innerSize: "0%",
        dataLabels: { enabled: false },
        borderColor: "transparent",
        slicedOffset: 8,
        borderRadius: 0,
      },
      series: { animation: false },
    },

    series: [
      {
        enableMouseTracking: true,
        animation: { duration: 2000 },
        colorByPoint: true,
        data: mfSchemeChartData,
      },
    ],

    legend: {
      enabled: true,
      align: "center",
      verticalAlign: "bottom",
      layout: "horizontal",
      itemStyle: { color: "var(--neutral-500)" },
      itemHoverStyle: { color: "var(--black)" },
      symbolHeight: 15,
      symbolWidth: 15,
      symbolRadius: 2,
    },
  };

  return <GKCharts chartOptions={options} />;
};

export default MFSchemeWeightage;
